
import {defineComponent} from 'vue'
import {UIStateDto} from "@/dtos/UIStateDto";
import {ErrorHandlerQueue} from "@/error/ErrorHandlerQueue";
import {DpExceptionsErrorHandler} from "@/error/handlers/DpExceptionsErrorHandler";
import {AxiosErrorHandler} from "@/error/handlers/AxiosErrorHandler";
import BaseTitle from "@/components/UI/BaseTitle.vue";
import BaseContainer from "@/components/UI/Bootstrap/BaseContainer.vue";
import {useToast} from "vue-toastification";
import AlertError2 from "@/components/UI/Bootstrap/Alert/AlertError2.vue";
import BaseCardBody from "@/components/UI/Bootstrap/Card/BaseCardBody.vue";
import BaseCardHeader from "@/components/UI/Bootstrap/Card/BaseCardHeader.vue";
import BaseCard from "@/components/UI/Bootstrap/Card/BaseCard.vue";
import {mapState} from "pinia";
import {useCustomerStore} from "@/stores/CustomerStore";
import BaseSpinner from "@/components/UI/Bootstrap/BaseSpinner.vue";
import {AbilityContext} from "@/context/AbilityContext";
import {CodeDescriptionRestDto} from "@/api/pharma-cpc-mgmt/models";
import {StatusEnum} from "@/api/enums/status-enum";
import InputText from "@/components/UI/InputText.vue";
import {DeliveryPickupLocationRestDtoModel} from "@/models/DeliveryPickupLocationRestDtoModel";
import {PageDetailModeEnum} from "@/models/enum/PageDetailModeEnum";
import {DeliveryPickupLocationRestService} from "@/services/rest/settings/DeliveryPickupLocationRestService";
import router from "@/router/router";
import {AddressRestDtoModel} from "@/models/AddressRestDtoModel";
import {EnumRestService} from "@/services/rest/enum/EnumRestService";
import {EnumClassNameOrderEnum} from "@/models/enum/EnumClassNameOrderEnum";

export default defineComponent({
  name: "DeliveryPickupLoactionDetail",
  components: {
    InputText,
    BaseContainer,
    BaseTitle,
    AlertError2,
    BaseCardBody,
    BaseCardHeader,
    BaseCard,
    BaseSpinner,
  },
  props: {
    mode: {
      type: String,
      required: true,
    }
  },
  data() {
    return {
      detailModel: DeliveryPickupLocationRestDtoModel.createWithDefaults(),
      allCountries: [] as CodeDescriptionRestDto[],
      toaster: useToast(),
      pageUI: UIStateDto.createWithDefaults(),
    }
  },
  mounted() {
    this.reloadContent();
  },
  computed: {
    ...mapState(useCustomerStore, ["getPharmacyCode"]),
    AbilityContext() {
      return AbilityContext;
    },
    statusOptions(): CodeDescriptionRestDto[] {
      return [
        {
          code: StatusEnum.PUBLISHED,
          description: this.$t('published'),
        },
        {
          code: StatusEnum.NOT_PUBLISHED,
          description: this.$t('notPublished'),
        },
      ];
    },
    countriesForDropdown(): CodeDescriptionRestDto[] {
      return [
        {
          code: '',
          description: '',
        },
        ...this.allCountries
      ];
    }
  },
  methods: {
    async reloadContent(): Promise<void> {
      this.pageUI
        .setNotReady()
        .clearError();

      try {
        this.allCountries = await EnumRestService.getInstance().getOrderEnumValuesByClassname(EnumClassNameOrderEnum.COUNTRY);
        if (this.mode === PageDetailModeEnum.NEW) {
          this.detailModel = DeliveryPickupLocationRestDtoModel.createWithDefaults();
        } else {
          this.detailModel = await DeliveryPickupLocationRestService.getInstance().getDeliveryPickupLocation(this.$route.params.id);
          if (this.detailModel.address === null) {
            this.detailModel.address = AddressRestDtoModel.createWithDefaults();
          }
        }
      } catch (exceptions: unknown) {
        this.setExceptions(exceptions);
      } finally {
        this.pageUI.setReady();
      }
    },
    async submitData(): Promise<void> {
      this.pageUI
        .clearError()
        .setNotReady();

      try {
        if (this.mode === PageDetailModeEnum.NEW) {
          await DeliveryPickupLocationRestService.getInstance().addDeliveryPickupLocation(this.detailModel);
          await router.push({name: 'delivery-pickup-locations'});
        } else {
          await DeliveryPickupLocationRestService.getInstance().updateDeliveryPickupLocation(this.detailModel, this.$route.params.id);
          await this.reloadContent();
        }
      } catch (exceptions: unknown) {
        ErrorHandlerQueue
          .create()
          .add(DpExceptionsErrorHandler.createWithDefaultUIStateBehavior(this.pageUI as UIStateDto))
          .catch(exceptions, true);
      } finally {
        this.pageUI.setReady();
      }
    },
    setExceptions(exceptions: unknown): void {
      ErrorHandlerQueue
        .create()
        .add(DpExceptionsErrorHandler.createWithDefaultUIStateBehavior(this.pageUI as UIStateDto))
        .add(AxiosErrorHandler.createWithDefaultUIStateBehavior(this.pageUI as UIStateDto))
        .catch(exceptions, true);
    }
  }
})
